'use client';
import { ArrowRight } from 'lucide-react';
import LinkNoPrefetch from '@/components/link-noprefetch';
import { DotBlockEditor } from '../shared/decodeTextBlock';
import { SvgIcon } from '../shared/SvgIcon';

function Layout01(props) {
    const { title, description, itemCta, icon, iconColor = 'text-fuschia-600' } = props;
    const hasImage = icon ? true : false;

    return (
        <div className="group relative size-full rounded-xl border border-white/10 bg-white/5 p-5 transition-all duration-300 hover:border-fuschia-600/40 hover:bg-white/10">
            <div className="flex h-[140px] min-h-[140px] items-start gap-4">
                {hasImage && (
                    <div
                        className={`flex size-12 shrink-0 items-center justify-center rounded-lg bg-fuschia-650/20 transition-colors group-hover:bg-fuschia-650/30 ${iconColor}`}>
                        <SvgIcon icon={icon} className={iconColor} size={24} />
                    </div>
                )}
                <div className="flex flex-col justify-between gap-1">
                    <div>
                        {title && (
                            <h3 className="mb-1 text-base font-semibold text-white">
                                {title.toString()}
                            </h3>
                        )}
                        {description && (
                            <div className="mb-3 text-xs leading-relaxed text-white/60">
                                {typeof description === 'string' ? (
                                    <p>{description.toString()}</p>
                                ) : (
                                    <DotBlockEditor blocks={description} />
                                )}
                            </div>
                        )}
                    </div>
                    {itemCta?.[0] && (
                        <LinkNoPrefetch
                            href={itemCta[0].url}
                            className="group/btn inline-flex items-center gap-1 text-xs font-semibold text-fuschia-600 transition-colors hover:underline">
                            {itemCta[0].urlName || 'Learn More'}
                            <ArrowRight className="size-3 transition-transform group-hover/btn:translate-x-1" />
                        </LinkNoPrefetch>
                    )}
                </div>
            </div>
        </div>
    );
}

const layoutComponents = {
    1: Layout01
};

function EnterpriseCard(props) {
    const { layout = 1 } = props;
    const LayoutComponent = layoutComponents[layout] || Layout01;

    return <LayoutComponent {...props} />;
}

export default EnterpriseCard;
